import React from 'react';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { DialogActions, DialogTitle } from 'Views/Page/Content/Modal/Components';
import { dataAttrs } from 'Helpers/Testing';
import {
  FDBodyText,
  FDDialogContent, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { dispatchCustomInsightUpdated } from 'Hooks/useRefreshEvent';
import moment from 'moment-timezone';

const lastEditFormat = 'MMMM Do [at] h:mmA z';

const RoadmapDeliverableCustomInsight = () => {
  const { resource, onSubmit } = useMetaLayoutContext();
  const { clearModalCollection } = useModalContext();

  const handleSubmit = async () => {
    const resp = await onSubmit();

    if (resp) {
      clearModalCollection();
      dispatchCustomInsightUpdated();
    }
  };

  return (
    <>
      <DialogTitle value={resource.attr('title')} />
      <FDDialogContent>
        <FDStack direction={'column'} {...dataAttrs('roadmap-deliverable-custom-insight-dialog')}>
          <MetaControlField attr={'content'} />
          <div style={{ paddingLeft: '14px' }}>
            <FDBodyText
              size={'sm'}
              value={resource.attr('lastEdit')
                ? `Last edited at: ${moment(resource.attr('lastEdit')).tz(moment.tz.guess()).format(lastEditFormat)}`
                : 'No edits made'}
            />
          </div>
        </FDStack>
      </FDDialogContent>
      <DialogActions>
        <FDPrimaryActionButton
          {...dataAttrs('dialog-submit')}
          onClick={handleSubmit}
          label={'Save'}
        />
      </DialogActions>
    </>
  );
};

export default RoadmapDeliverableCustomInsight;
